module.exports = __webpack_public_path__ + "media/images/flags/KY-e506a406f108908d3f51f0dc15062e0e.svg";